
import { Component, OnInit } from '@angular/core';
import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CourseManagementService } from "../course-management.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { ConfirmationComponent } from 'src/app/common/components/confirmation/confirmation.component';
@Component({
  selector: 'app-view-course',
  templateUrl: './view-course.component.html',
  styleUrls: ['./view-course.component.css']
})
export class ViewCourseComponent implements OnInit {
  closeResult: string;
  courseDetail: any;
  courseList = [];
  featureList = [];
  finalFeatureList = [];
  temp: any;
  feature: string;
  courseCount: any;
  courseId: any;
  statusFormSubmitted: boolean = false;

  private modalRef1: NgbModalRef;
  statusForm: FormGroup;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "blocked", name: "Blocked" },
  ];
  constructor(private formBuilder: FormBuilder, private modalService: NgbModal, private CourseManagementService: CourseManagementService, private spinner: NgxSpinnerService) { }

  ngOnInit() {

    this.spinner.show();
    this.getCoureList();
    // this.startLoadingSpinner();
  }

  startLoadingSpinner() {

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 3000);
  }
  getCoureList() {
    this.spinner.show();
    this.CourseManagementService.getCourseList().subscribe(res => {

      if ((res["message"] = "Success")) {
        this.courseList = res.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }




  // USER UPDATE STATUS BLOCK
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }
  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.courseDetail = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef1 = this.modalService.open(content, this.modelOptions);
    this.modalRef1.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.courseId = row;
    this.courseDetail = row;
    this.modalRef1 = this.modalService.open(content, this.modelOptions);
    this.modalRef1.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        courseId: this.courseDetail["courseId"],
        status: this.statusForm.controls.newStatus.value
      };
      this.CourseManagementService.updateCourse(finalObj).subscribe(data => {
        this.spinner.hide();
        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User status updated successfully!", "success");
          this.modalRef1.close();
          this.getCoureList();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  confirmDeleteRecord(record: any) {
    let modalRef1 = this.modalService.open(ConfirmationComponent, this.modelOptions);
    modalRef1.componentInstance.content = "Are you sure you want to delete this record?";
    modalRef1.componentInstance.leftButton = "No";
    modalRef1.componentInstance.rightButton = "Yes";
    modalRef1.result.then(
      (data: any) => {
        if (data == "yes") {
          this.deleteRecord(record);
        }
      },
      (reason: any) => { }
    );
  }

  deleteRecord(record: any) {
    this.spinner.show();
    this.CourseManagementService.deleteCourse(this.courseId).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "Course Deleted successfully!", "success");
        this.modalRef1.close();
        this.spinner.hide();
        this.getCoureList();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }

}

